// @flow
import React from 'react';
import { TextField } from '@src/formik-utils/FormFields';
import { CUSTOM_DISCOUNTS_GLOBAL_DISCOUNT_CONFIG } from '@src/configuration/custom-discounts';
import { TEXT_NUMBER_INPUT_TYPE } from '@src/formik-utils/consts';

export const CommitGlobalDiscountsTextFieldContainer = ({ readOnlyMode }) => {
  const { displayName, backendFieldName, icon } = CUSTOM_DISCOUNTS_GLOBAL_DISCOUNT_CONFIG;

  return (
    <TextField
      addLabel={false}
      disabled={readOnlyMode}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      icon={icon}
      type={TEXT_NUMBER_INPUT_TYPE}
    />
  );
};
